/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { Remember } from '@/model/global/GlobalSettings'

const entity = {
  _langsname: {
    displayName: 'name'
  },
  sumTotal: {}
}
const config = {
  load: async function (filter) {
    const [fromDate, toDate] = filter[0].dateFilter
    const res = (await hillo.get('BackendData.php?op=categoryReportV2', {
      fromDate,
      toDate
    })).content
    res.forEach(it => {
      it._langsname = it.langs.find(it => it.lang.toLowerCase() === Remember.lang.toLowerCase()).name
    })
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)
